import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, filter, map, of, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isLoading$.pipe(
      filter(isLoading => !isLoading),
      take(1),
      switchMap(() => this.authService.isAuthenticated$.pipe(take(1))),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          this.authService.loginWithRedirect({ appState: { target: state.url } });
          return of(false);
        }

        return this.authService.user$.pipe(
          take(1),
          map(user => {
            if (user?.email && user?.email_verified) {
              return true;
            }

            this.router.navigate(['notVerified']);
            return false;
          })
        );
      })
    );
  }
}
